// @ts-nocheck
import React, { createContext, useContext, useEffect, useState } from 'react';

const FX_CACHE_KEY  = 'ac_fx_rates';
const FX_CACHE_TTL  = 24 * 60 * 60 * 1000; // 24 h
const CURRENCY_KEY  = 'ac_currency';
const FX_API_URL    = 'https://open.er-api.com/v6/latest/USD';

export const CURRENCIES = [
  { code: 'USD', symbol: '$',    label: 'USD ($)' },
  { code: 'EUR', symbol: '€',    label: 'EUR (€)' },
  { code: 'GBP', symbol: '£',    label: 'GBP (£)' },
  { code: 'CHF', symbol: 'CHF ', label: 'CHF'     },
  { code: 'JPY', symbol: '¥',    label: 'JPY (¥)' },
  { code: 'TRY', symbol: '₺',    label: 'TRY (₺)' },
];

const CurrencyContext = createContext({
  currency: 'USD',
  setCurrency: () => {},
  rates: null,
});

async function loadRates() {
  try {
    const raw = localStorage.getItem(FX_CACHE_KEY);
    if (raw) {
      const { rates, ts } = JSON.parse(raw);
      if (Date.now() - ts < FX_CACHE_TTL) return rates;
    }
  } catch { /* corrupt cache — fall through */ }

  const res = await fetch(FX_API_URL);
  if (!res.ok) throw new Error(`FX fetch failed ${res.status}`);
  const data = await res.json();
  try {
    localStorage.setItem(FX_CACHE_KEY, JSON.stringify({ rates: data.rates, ts: Date.now() }));
  } catch { /* storage full — ignore */ }
  return data.rates;
}

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    try { return localStorage.getItem(CURRENCY_KEY) || 'USD'; } catch { return 'USD'; }
  });
  const [rates, setRates] = useState(null);

  useEffect(() => {
    loadRates().then(setRates).catch(() => { /* silent — salaries stay in USD */ });
  }, []);

  function setCurrency(code) {
    setCurrencyState(code);
    try {
      if (localStorage.getItem('ac_cookie_consent') === 'accepted') {
        localStorage.setItem(CURRENCY_KEY, code);
      }
    } catch { /* ignore */ }
  }

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, rates }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
